/**
 * Shown when Continue is pressed with an address the API would reject.
 *
 * Worded to hold in both address modes: the search bar has its "Enter address manually" link right
 * under it, and the manual fields are already on screen, so neither is pointed at by name.
 */
export const INCOMPLETE_ADDRESS_MESSAGE =
  'Please complete your address: we need the street number, street name, city, state, and ZIP code.';
